import { render, staticRenderFns } from "./DiscrepanciesBarPlotByClient.vue?vue&type=template&id=5325ae8b"
import script from "./DiscrepanciesBarPlotByClient.vue?vue&type=script&lang=js"
export * from "./DiscrepanciesBarPlotByClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports